//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "PublicLayout",
  created() {
  }
}
